import { namesStartingWithLetter } from "./variables";

function filterData(letter, arr) {
	let namesStartingWithLetter = arr
		.filter((object) => object.phone.startsWith(`${letter}`))
		.map((object) => object.phone);
	let listContainer = document.querySelector(".brendy__list");
	listContainer.innerHTML = "";
	if (namesStartingWithLetter.length > 0) {
		let ul = document.createElement("ul");
		namesStartingWithLetter.forEach((name) => {
			let li = document.createElement("li");
			li.textContent = name;
			ul.appendChild(li);
		});
		listContainer.appendChild(ul);
	} else {
		listContainer.textContent = "No elements";
	}
}

export default filterData;
